import { ActionTree } from 'vuex';
import { CommentsState, CommentAdd, CommentEdit } from './models';
import { CommentView } from './models';
import { RootState } from '@/store';
import api from './api';
import { Mutations } from './mutations';
import { ErrorApi } from '@/core/api/ErrorApi';
import Notify from '@/shared/services/Notify/Notify';

export enum Actions {
  FETCH_COMMENTS = 'FETCH_COMMENTS',
//   FETCH_EVENT = 'FETCH_EVENT',
  ADD_COMMENT = 'ADD_COMMENT',
  EDIT_COMMENT = 'EDIT_COMMENT',
  DELETE_COMMENT = 'DELETE_COMMENT',
}

export const actions: ActionTree<CommentsState, RootState> = {

  async [Actions.FETCH_COMMENTS]({ commit }, contentObjectId: number | null) {
    commit(Mutations.GET_COMMENTS_REQUEST);
    await api.fetchComments(contentObjectId === undefined ? null : contentObjectId).then(
      (payload: CommentView[]) => {
        commit(Mutations.GET_COMMENTS_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_COMMENTS_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.ADD_COMMENT]({},  newComment: CommentAdd) {
    await api.addComment(newComment).then(
      () => {
        Notify.success(`Komentarz został dodany.`);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.EDIT_COMMENT]({},  comment: CommentEdit) {
    await api.editComment(comment).then(
      () => {
        Notify.success(`Komentarz został zmodyfikowany.`);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.DELETE_COMMENT]({ dispatch }, id: number) {
    await api.deleteComment(id).then(
      () => {
        Notify.success(`Komentarz został usunięty.`);
        dispatch(Actions.FETCH_COMMENTS);
      },
      (error: ErrorApi) => {
        Notify.errorApi(error);
      },
    );
  },

};
